export const REQUIRED = "Required";

export const OPTIONAL = "Optional";

export const CHECK = "✓";
